// material-ui
import { useMediaQuery, Container, Link, Typography, Stack, Alert, IconButton } from '@mui/material';
import { useLocation } from 'react-router-dom';
import CloseIcon from "@mui/icons-material/Close";
import FeedbackIcon from "@mui/icons-material/Feedback"
// ==============================|| HEADER FEEDBACK ||============================== //

import { useDispatch } from 'react-redux';
import { forceCloseFeedbackPrompt } from "store/user/user.action";

const FeedbackHeader = (feedbackDisplay) => {
    const location = useLocation();
    const { pathname } = location;

    const { displayFeedback, setDisplayFeedback } = feedbackDisplay

    const dispatch = useDispatch();

    return (
        <Stack>
            {
                pathname != "/feedback" && displayFeedback == true &&
                    <Alert severity="warning" icon={<FeedbackIcon fontSize="inherit"/>} sx={{ mb: 2 }}
                    action={
                    <IconButton onClick={() => {
                        setDisplayFeedback(!displayFeedback);
                        dispatch(forceCloseFeedbackPrompt());
                    }}>
                        <CloseIcon></CloseIcon>
                    </IconButton>
                    }
                    >
                        <Typography variant="body1" gutterBottom>
                            We'd love your feedback—please take a moment to complete our quick{"\u00A0"}
                            <Link href="/feedback" underline="hover" target="_blank">
                            survey
                            </Link>
                            {"\u00A0"}and help us serve you better.
                        </Typography>
                    </Alert>
            }
        </Stack>
    );
};

export default FeedbackHeader;
